import React, { FC, useContext, useEffect } from 'react';
import Page2ColumnLayout from '../../components/utility/page2-column-layout';
import MainArea from '../../components/utility/main-area';
import { useTranslation } from '../../hooks/useTranslation';
import Helmet from 'react-helmet';
import ClosedAccounts from '../../components/closed-accounts/ClosedAccounts';
import { featureFlagsContext } from '../../providers/FeatureFlagsProvider';
import { navigate } from 'gatsby';
import ROUTES from '../../routes';
import { Router } from '@reach/router';
import ClosedAccountsPaymentHistoryPage from './closed-accounts-payment-history';
import { NoAccountsRedirectContext } from '../../providers/NoAccountsRedirectConfigProvider';
import AccountLeftNavBlock from '../../components/utility/account-left-nav-block';

const ClosedAccountsPage: FC = () => {
  const { t } = useTranslation();
  const { isClosedAccountsEnabled, loading, flagsResolved } = useContext(
    featureFlagsContext,
  );
  const { setIgnoreNoAccounts } = useContext(NoAccountsRedirectContext);

  if (!isClosedAccountsEnabled && !loading && flagsResolved) {
    //eslint-disable-next-line @typescript-eslint/no-floating-promises
    navigate(ROUTES.ACCOUNT);
  }

  useEffect(() => {
    setIgnoreNoAccounts(true);

    return () => setIgnoreNoAccounts(false);
  }, []);

  return (
    <>
      <Helmet>
        <title>{t('CLOSED_ACCOUNTS')}</title>
      </Helmet>

      <Page2ColumnLayout leftColumn={<AccountLeftNavBlock />}>
        <MainArea>
          <Router basepath="/">
            <ClosedAccounts path={`${ROUTES.CLOSED_ACCOUNTS}/*`} />
            <ClosedAccountsPaymentHistoryPage
              path={`${ROUTES.CLOSED_ACCOUNTS_HISTORY}`}
            />
          </Router>
        </MainArea>
      </Page2ColumnLayout>
    </>
  );
};

export default ClosedAccountsPage;
